<template>
	<select :id="id" v-model="selected" class='form-control my-control' data-num='f_9' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const FORESTRY = 'forestrie_list.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'forestry',
		data: function () { 
			return {
				selected: '0',
				options: [],
				id: `${this.type}_forestry`
			}
		},
		props: {
			type: '',
			reg_id: '',
			f_id: '',
		},
		methods: {
			fill: function (id) {
				//console.log(id)
				fetch(DB + FORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						// this.selected = select ? select : '0'
						this.options = [{id: '0', name: ''}, ...data];
						this.selected = this.f_id ? this.f_id : '0'
					}
					else {
						this.selected = '0'
						this.options = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		watch: {
			reg_id (id) {
				if (id) {
					this.fill(id)
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// forestry.vue?4ec82d21